// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"442":"08961f27","787":"427d7c87"}[chunkId] + ".chunk.js";
};